// Versioning
export const BLOKKENDOOS_VERSION = "2025-09-09";
export const PREPR_VERSION_HEADER = {
  "Prepr-Version": "2025-05-27",
};
